import { render } from "./Talleres.vue?vue&type=template&id=2cd5b8f2&scoped=true"
import script from "./Talleres.vue?vue&type=script&lang=js"
export * from "./Talleres.vue?vue&type=script&lang=js"

import "./Talleres.vue?vue&type=style&index=0&id=2cd5b8f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd5b8f2"]])

export default __exports__